import { PortionMaterialSizeDescriptionField } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/Components';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { Field, TextOutput } from '../../../../../Core';
import { NamePrefixModifier, withInjectedProps } from '../../../../../Core/InjectedPropsContext';
import { ListFieldSection } from '../../../../../Layout';
import { IWorksheetComponent } from '../../../../Core';

//Used for the coarsest portion, which is at path WholePortion.Separation.CoarsePortion
let CoarsePortionSievingMassesSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector, namePrefix }) => {
  const wholePortionPrefix = namePrefix!.substring(0, namePrefix!.lastIndexOf('WholePortion') + 'WholePortion'.length);
  const isWholePortionWashed = useSelector(
    pipe(createWorksheetSelector!(`${wholePortionPrefix}.Washing.IsWashed`, false), valueOrDefault(false))
  );
  const isInitialSeparationPerformed = useSelector(
    pipe(createWorksheetSelector!(`data.Preparation.InitialSeparationPerformed`, false), valueOrDefault(false))
  );

  return (
    <ListFieldSection>
      <PortionMaterialSizeDescriptionField />
      <NamePrefixModifier namePrefix={wholePortionPrefix}>
        <Field input={<TextOutput />} name="Masses.DryMass" label="Specimen Total Dry Mass" />
        <Field
          input={<TextOutput />}
          name="Washing.WashedDryMass"
          visible={isWholePortionWashed}
          label="Sieve Portion Washed Material Dry Mass"
        />
      </NamePrefixModifier>
      <Field
        input={<TextOutput />}
        label="Sieve Portion Material Dry Mass"
        name="Masses.DryMass"
        visible={isInitialSeparationPerformed && !isWholePortionWashed}
      />
    </ListFieldSection>
  );
};
CoarsePortionSievingMassesSection = withInjectedProps(CoarsePortionSievingMassesSection);

export { CoarsePortionSievingMassesSection };
export default CoarsePortionSievingMassesSection;
